//import moment from 'moment';
import moment from 'moment-timezone';

import sanitize from 'sanitize-filename';

export const browserTimezone = moment.tz(Intl.DateTimeFormat().resolvedOptions().timeZone).zoneAbbr();

export function get_modified_image_url (orig_url,modifier_string) {
  const array = orig_url.split("/");
  const modified_url = `${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/${modifier_string}/${array[5]}`;
  return modified_url;
}

export function get_link_base_url() {
  let link_base_url = window.location.protocol + '//' + window.location.hostname + '/';
  if (window.location.hostname === 'localhost' && window.location.port === '3000') {
    // special case for visual-studio (local machine) development
    link_base_url = window.location.protocol + '//' + window.location.hostname + ':' + window.location.port + '/';
  }
  return link_base_url;
}

export function assembleNickname (entity_info) {
  if (entity_info.entity_name) {
    return entity_info.entity_name;
  }
  
  let nickname_array = [];
  if (entity_info.firstname) {
    nickname_array.push(entity_info.firstname);
  }
  if (entity_info.lastname) {
    nickname_array.push(entity_info.lastname);
  }
  return nickname_array.join(' ');
}

// for generating friendly-url
export function slugify(string) {
  const a = 'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;';
  const b = 'aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------';
  const p = new RegExp(a.split('').join('|'), 'g');

  return string.toString().toLowerCase()
    .replace(/\s+/g, '-') // Replace spaces with -
    .replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
    .replace(/&/g, '-and-') // Replace & with 'and'
    .replace(/[^\w\-]+/g, '') // Remove all non-word characters
    .replace(/\-\-+/g, '-') // Replace multiple - with single -
    .replace(/^-+/, '') // Trim - from start of text
    .replace(/-+$/, ''); // Trim - from end of text
}

export function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i <ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

export function getRelativeTime (inc_unixtime) {
  let relative_time = moment((inc_unixtime - 1) * 1000).fromNow();
  return relative_time;
}

// Function to get days,hours,minutes,day,year
export function dateConvert(curr_Date) {
  moment.locale('en');
  var m_date = moment(curr_Date).format('DD');
  var m_month = moment(curr_Date).format('MMM');
  var s_month = moment(curr_Date).format('MM');
  var m_Time = moment(curr_Date).format('h:mm A');
  var m_day = moment(curr_Date).format('ddd');
  var m_year = moment(curr_Date).format('YYYY');
  var common_time = moment(curr_Date).format('YYYY MM DD');
  var days = new Array(7);
  days[0] = "Sun";
  days[1] = "Mon";
  days[2] = "Tue";
  days[3] = "Wed";
  days[4] = "Thu";
  days[5] = "Fri";
  days[6] = "Sat";
  const dateAr = { day: m_day, month: m_month, date: m_date, hour: m_Time, year: m_year, monthn: s_month,common_time:common_time }
  return dateAr

}

// Function to convert unix time to normal time.
export function unixDateConversion(curr_Date) {
  var start_time = new Date(curr_Date * 1000);
  const converted_date = start_time
  return converted_date
}

// Function to check date differences between two dates.
// JBB this is wrong logic - produces bad results
/*
export function DaysDiff(curr_Date) {
  var date1_today = moment().format('L');
  var date2_event_date = moment(curr_Date).format('L');
  var start = moment(date1_today);
  var end = moment(date2_event_date);
  const converted_date = end.diff(start, "days")
  return converted_date
}
*/
export function DaysDiff(curr_Date) {
  let timeDiffer = timeDiff(curr_Date);
  return timeDiffer.daysDiff;
}

// Function to check hour differences between two dates.
// JBB this is wrong logic - produces bad results
/*
export function HoursDiff(curr_Date) {
  try{
    let date1_today = moment(curr_Date).format('HH');
    let cur_date = new Date()
    let date2_event_date = moment(cur_date).format('HH');
    let final_Result_Temp = date1_today - date2_event_date;
    let final_Result=Math.abs(final_Result_Temp);
    if (final_Result > 0) {
      const converted_date = final_Result;
      return converted_date
    }
  }
  catch(error)
  {
  }
}
*/
export function HoursDiff(curr_Date) {
  let timeDiffer = timeDiff(curr_Date);
  return timeDiffer.hoursDiff;
}


// Better Function to check days,hours,minutes,seconds differences between two dates.
export function timeDiff(curr_Date) {
  try {
    var dateFuture = curr_Date;
    var dateNow = new Date();
    var seconds = Math.floor((dateFuture - (dateNow)) / 1000);
    var minutes = Math.floor(seconds / 60);
    var hours = Math.floor(minutes / 60);
    var days = Math.floor(hours / 24);
    hours = hours - (days * 24);
    minutes = minutes - (days * 24 * 60) - (hours * 60);
    seconds = seconds - (days * 24 * 60 * 60) - (hours * 60 * 60) - (minutes * 60);
    // console.log("Time until new year: Days: " + days + " Hours: " + hours + " Minutes: " + minutes + " Seconds: " + seconds)
    const timeDiffRes = { daysDiff: days, hoursDiff: hours, minsDiff: minutes, secDiff: seconds }
    return timeDiffRes
  }
  catch (error) {
  }
}


// Current site URL example http://localhost:3000/searchResults
export const CurrentUrl = window.location.href;
// site pathname example /searchResults
export const pathname = window.location.pathname;
// site origin example http://localhost:3000
export const origin = window.location.origin;

export function setLocalStorageSubVal (key,sub_key,value) {
  try {
    const existing_value = localStorage.getItem(key);
    let parsedData = JSON.parse(existing_value);
    parsedData[sub_key] = value;
    localStorage.setItem(key, JSON.stringify(parsedData));
    
  } catch (error) {
    let parsedData = {
      [sub_key]: value
    }
    localStorage.setItem(key, JSON.stringify(parsedData));
  }  
}

// Local storage set Func
export function saveKey(key,value) {
  try {
    localStorage.setItem(key, value);
  } catch (error) {
  }
}
// Local storage get Func
export function getKey(key) {
  try {
    const value = localStorage.getItem(key);
    const parsedData=JSON.parse(value)
    return parsedData;
  } catch (error) {
  }
}
// Current unix Time stamp
export const current_unix_stamp=moment().unix();

export function get_current_unix_stamp() {
  return moment().unix();
}

// 10 days difference with current unix timestamp
export function timeStampDiff(timeDifference) {
  try {
    const parsedData=moment(Date.now() - timeDifference * 24 * 3600 * 1000).format('YYYY-MM-DD') 
    return parsedData;
  } catch (error) {
  }
}

// Subtract n number of days from current unix time stamp
export function subtractDays(days) {
  try {
    var d = new Date(); // today!
    var x = days; // go back n days!
    let parsedData  = d.setDate(d.getDate() - x);
    return parsedData;
  } catch (error) {
  }
}

// Date to unix timestamp
export function unixTimeStamp(timeStamp) {
  try {
    const parsedData = Math.floor(new Date(timeStamp).getTime() / 1000);
    return parsedData;
  } catch (error) {
  }
}

// Function to convert milliseconds to seconds
export function millisToSeconds(millis) {
  var seconds = ((millis % 60000) / 1000).toFixed(0);
  return seconds;
}

export const massageFriendlyUrl = function (friendly_url) {
  let massaged_friendly_url = friendly_url;
  massaged_friendly_url = massaged_friendly_url.toLowerCase().replace(/\W/g, "-");
  massaged_friendly_url = slugify(massaged_friendly_url);
  massaged_friendly_url = sanitize(massaged_friendly_url);
  return massaged_friendly_url;
};

// To get the query string from Link
export const getQueryString = function (field, url) {
  var href = url ? url : window.location.href;
  var reg = new RegExp('[?&]' + field + '=([^&#]*)', 'i');
  var string = reg.exec(href);
  return string ? string[1].replace(/%20/g, " ") : null;
};


// To get unique values from Array
// eslint-disable-next-line no-extend-native
Array.prototype.contains = function(v) {
  for (var i = 0; i < this.length; i++) {
    if (this[i] === v) return true;
  }
  return false;
};

// eslint-disable-next-line no-extend-native
Array.prototype.unique = function() {
  var arr = [];
  for (var i = 0; i < this.length; i++) {
    if (!arr.contains(this[i])) {
      arr.push(this[i]);
    }
  }
  return arr;
}
// To get unique values from Array Ends here